import { State } from 'redux/utils/List'

export default State({}, { isMinimal: true })